import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse } from '../../shared/config';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'wego-personprofile-failure',
  template: `
  <section class="content">
		<div class="col-md-12 text-center">
        <p class="headerror"> 404</p>
          <h3><i class="fa fa-warning text-yellow"></i> Oops! Link Expired.</h3>
          <p>
            This invite URL is  not valid anymore or expired.
          </p>
        Please  <a routerLink="/">Login</a> here.
		</div>
  </section>
  `,
  styles: [`.headerror {
                font-size: 150px !important;
                font-weight: normal;
                line-height: 100px;
                margin-top: 50px;
                color: #2ba2aa;
          }`]
})

export class PersonProfileFailurComponent implements OnInit, OnDestroy {
  constructor() {

  }
  ngOnInit() {

  }
  ngOnDestroy() { console.log('ngOnDestroy'); }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/personprofile/componets/personprofilefailure.componets.ts